import React from 'react';
import { InputText, InputTextWithFloatingLabel } from '../../../components/tools/BootstrapControls';
import * as apiCaller from '../../../helpers/apiCaller'
import serviceUrls from '../../../constants/serviceUrls';
import uiHelpers from '../../../helpers/uiHelpers';
import { Redirect  } from "react-router-dom";
import moment from 'moment';
import { convertMeterStatus, convertWasReadingIntegrationStatus } from '../../../helpers/converters';
import { isPositiveWholeNumber } from '../../../helpers/validators';
class SearchMeters  extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            keyword:'',
            meterIdStr:'',
            meterIdError:null,
            meterId:null,
            searching:false,
            result:null,
            redirectTo : null
        }
    }

    async componentDidMount() {
        
    }

    onMeterIdChange = (e) => {
        if(e.target.value.trim() == '' || isPositiveWholeNumber(e.target.value)) {
            this.setState({meterIdStr:e.target.value, meterIdError:null, meterId:parseInt(e.target.value)})
        } else {
            this.setState({meterIdStr:e.target.value, meterIdError:'Not a valid ID', meterId:null})
        }
    }


    onKeywordChanged = (e) => {
        this.setState({keyword:e.target.value})
    }

    search = async (e) => {
        e.preventDefault();
        uiHelpers.showProgressOnTop('Please wait...');
        this.setState({searching:true})
        await apiCaller.post(serviceUrls.admin.searchMeter,{meterId:this.state.meterId,keyword:this.state.keyword})
        .then((data)=>{
            this.setState({
                result:data.result,
                searching:false
            })
        })
        .finally(()=>{
            uiHelpers.hideProgressOnTop();
        });
    }

    openMeter = (m) => {
        this.setState({redirectTo:'/admin/meter/' + m.id})
    }

    render() {
        if(this.state.redirectTo) return <Redirect to={this.state.redirectTo}  />;
        return <>

            <h3 class="mb-3">Search Meters</h3>

            <form action={""} onSubmit={this.search} >

                <div class="row mb-2">
                    <div class="col-md-2">
                        <InputText
                            className="mb-3"
                            value={this.state.meterIdStr} 
                            disabled={this.state.callingBackend}
                            onChange={this.onMeterIdChange}
                            label={<>Meter ID</>}
                            error={this.state.meterIdError}
                        />
                    </div>
                    <div class="col-md-5">
                        <InputText
                            className="mb-3"
                            value={this.state.keyword} 
                            disabled={this.state.callingBackend}
                            onChange={this.onKeywordChanged}
                            label={<>Keyword <i className='fs-80'>(Approval / ESID / DAS Workspace ID )</i></>}
                        />
                    </div>
                </div>

                <div className='mb-3'>
                    <button className='btn btn-primary' type="submit" disabled={this.state.searching}>Search</button>
                </div>

            </form>

            {this.state.result && <>
                {this.state.result.length==0 && <div className='p-4 text-center bg-light'>
                    No meter found from this keyword
                </div>}

                {this.state.result.length>0  && <ul className={`list-group ${this.state.searching ? 'opacity-25':''}`}>
                    {this.state.result.map(m=><li class="list-group-item">
                        <div className='row'>
                            <div className='col-md-4 mb-3'>
                                {m.meterSiteId.meterSiteId}
                                <br/><span class="fs-80 text-secondary">Meter ID: #<b>{m.id}</b></span>
                                <br/><span class="fs-80 text-secondary">Created: <b>{moment(m.createdDate).format('DD/MM/YYYY')}</b></span>
                            </div>
                            <div className='col-md-6 mb-3'>
                                <span class="fs-80 text-secondary">Meter Status: <b className='text-primary'>{convertMeterStatus(m.status)}</b></span>
                                <br/><span class="fs-80 text-secondary">LID: {m.isLidExempted ? <i className='text-warning'>Exempted</i> : m.meterLid ? <b>{m.meterLid.lid.displayText}</b> : <i>Empty</i>}</span>
                                <br/><span class="fs-80 text-secondary">Manufacturer and Model: <b>{m.meterTypeModel.name}</b></span>
                                {m.meterIntegration && <>
                                    <br/><span class="fs-80 text-secondary">Reading Integration Status: <b className='text-primary'>{convertWasReadingIntegrationStatus(m.meterIntegration.wasReadingIntegrationStatus)}</b></span>
                                </>}
                                
                            </div>
                            <div className='col-md-2 text-end'>
                                <a href={`/#/admin/meter/${m.id}`} className={`btn btn-primary btn-sm ${this.state.searching && 'disabled'}`}>Meter Details</a>
                            </div>
                        </div>
                    </li>)}
                </ul>}
            </>}
            
        </>
    }
}

export default SearchMeters;
